import React, { useState } from 'react';
import { useFeatureFlag } from '@/providers/FeatureFlags';
import Flask from '@/components/Icons/Debug';
import Button from '@/components/DesignLibrary/Button';

import Modal from './Modal';
import s from './ResponseDebugger.module.scss';

type Props = {
  field: {
    key: string;
    type: string;
  };
  index: number | null;
};

const ResponseDebugger: React.FC<Props> = ({ field, index }) => {

  const isFeatureFlagEnabled = useFeatureFlag('can-debug-questionnaire-responses');
  const [isOpen, setIsOpen] = useState(false);

  if (
    !isFeatureFlagEnabled
    || field.type === 'explanation'
    || field.type === 'list'
    || field.type === 'table'
  ) {
    return null; // Do not render if the feature flag is disabled
  }

  return (
    <>
      <Button
        variant="secondary"
        size="xs"
        className={s.debugButton}
        onClick={() => setIsOpen(true)}
        aria-label="Open Response Debugger"
      >
        <Flask size={16} color="var(--color-gray-50)" />
      </Button>
      {isOpen && (
        <Modal
          onClose={() => setIsOpen(false)}
          fieldKey={field.key}
          row={index}
        />
      )}
    </>
  );
};

export default ResponseDebugger;
